module.exports = __webpack_public_path__ + "static/media/edit_pencil-d.ad1c82bf.svg";